import apiClient from './api';

/** Trashed project kinds as the API names them (the dashboard calls websites 'site'). */
export type TrashKind = 'website' | 'video';

export interface TrashItem {
    kind: TrashKind;
    id: string;
    name: string;
    thumbnailUrl: string | null;
    /** Website was published when trashed (it went offline). */
    wasLive: boolean;
    /** Video only: 'portrait' | 'square' | 'landscape'. */
    format?: string | null;
    deletedAt: string;
    /** When the hourly purge deletes it for good. */
    purgeAt: string;
}

export interface TrashList {
    retentionDays: number;
    items: TrashItem[];
}

const data = <T>(p: Promise<{ data: { data: T } }>) => p.then((r) => r.data.data);

/** Soft-deleted projects (GET /trash). Calls throw on failure. */
export const trashService = {
    list: () => data<TrashList>(apiClient.get('/trash')),
    restore: (kind: TrashKind, id: string) => data<unknown>(apiClient.post(`/trash/${kind}/${encodeURIComponent(id)}/restore`)),
    /** Delete forever. */
    purge: (kind: TrashKind, id: string) => data<{ deleted: boolean }>(apiClient.delete(`/trash/${kind}/${encodeURIComponent(id)}`)),
};

/** Best-effort error message from an axios error. */
export const trashError = (e: unknown, fallback: string): string => {
    const m = (e as any)?.response?.data?.message;
    return (Array.isArray(m) ? m[0] : m) || fallback;
};
